var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.5 46.5",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 23.25,
    r: 22.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 21.42l8.08-9.58h-1.74l-7.11 8.46-5.75-8.46H12.1l8.79 12.82-8.39 9.99h1.74l7.44-8.85 6.07 8.85h6.61l-9.04-13.23zm-10.37-8.07h3.05l13.51 19.79h-3L14.97 13.35z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ni41IDQ2LjUiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSI+CiAgPGNpcmNsZSBjeD0iMjMuMjUiIGN5PSIyMy4yNSIgcj0iMjIuNCIgc3Ryb2tlLXdpZHRoPSIxLjciIC8+CiAgPGc+CiAgICA8cGF0aCBkPSJNMjUuMzQsMjEuNDJsOC4wOC05LjU4aC0xLjc0bC03LjExLDguNDYtNS43NS04LjQ2aC02LjcybDguNzksMTIuODItOC4zOSw5Ljk5aDEuNzRsNy40NC04Ljg1LDYuMDcsOC44NWg2LjYxbC05LjA0LTEzLjIzWiAKICAgICAgICAgICAgIE0xNC45NywxMy4zNWgzLjA1bDEzLjUxLDE5Ljc5aC0zTDE0Ljk3LDEzLjM1WiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPC9nPgo8L3N2Zz4KCg==";
export { SvgIconX as ReactComponent };